import { Component, OnInit } from '@angular/core';
import { LoadingAndErrors } from '../../../classes';
import { OtherOrderApi } from '../../../../assets/js/lb-sdk';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-cronjobs',
  templateUrl: './cronjobs.component.html',
  styleUrls: ['./cronjobs.component.css']
})
export class CronjobsComponent extends LoadingAndErrors implements OnInit {
  cronjobs;

  constructor(
    private otherOrdersApi: OtherOrderApi,
    private toast: ToastrService
  ) {
    super();
  }

  ngOnInit() {
    this.getCronjobs();
  }

  getCronjobs() {
    this.clearErrors();
    this.loading.cronjobs = true;
    this.otherOrdersApi
      .cronStatus()
      .pipe(finalize(() => {
        this.loading.cronjobs = false;
      }))
      .subscribe(
        response => {
          this.cronjobs = response && response.cronjobs || [];
        },
        error => {
          this.errors.cronjobs = error && error.message || 'Loading batch jobs failed.';
        }
      );
  }
}
